import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb, Button, Empty, Spin, Tabs, Tag } from "antd";
import { EditOutlined, HomeOutlined } from "@ant-design/icons";
import service from "../../api/FetchInterceptor";
import AddFormation from "./add";
import FormationParts from "./parts";
import FormationPrices from "./prices";
import FormationStudents from "./students";

const ShowFormation = () => {
    const { id } = useParams();
    const [formation, setFormation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editOpen, setEditOpen] = useState(false);

    const load = useCallback(() => {
        service({ method: "GET", url: `admin/formations/${id}` })
            .then(setFormation)
            .finally(() => setLoading(false));
    }, [id]);

    useEffect(() => {
        load();
    }, [load]);

    if (loading) {
        return (
            <div className="flex justify-center py-20">
                <Spin />
            </div>
        );
    }

    if (!formation) return <Empty className="mt-20" description="Formation introuvable" />;

    return (
        <>
            <AddFormation id={formation.id} open={editOpen} setOpen={setEditOpen} onSuccess={load} />

            <div className="mt-8">
                <Breadcrumb
                    items={[
                        { href: "/dashboard", title: <HomeOutlined /> },
                        { href: "/dashboard/formations", title: "Formations" },
                        { title: formation.title },
                    ]}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 rounded-xl border border-gray-200 bg-white p-6 md:flex-row md:items-center">
                {formation.cover_image_url ? (
                    <img src={formation.cover_image_url} alt="" className="h-24 w-40 rounded-lg object-cover" />
                ) : (
                    <div className="h-24 w-40 rounded-lg bg-gray-100" />
                )}

                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                        <h1 className="m-0 text-xl font-semibold">{formation.title}</h1>
                        {formation.is_published ? <Tag color="green">Publiée</Tag> : <Tag>Brouillon</Tag>}
                    </div>
                    {formation.subtitle && <p className="m-0 mt-1 text-gray-500">{formation.subtitle}</p>}
                    <p className="m-0 mt-2 text-xs text-gray-400">
                        {formation.parts_count} partie(s) · {formation.enrollments_count} inscrite(s) · /{formation.slug}
                    </p>
                </div>

                <Button icon={<EditOutlined />} onClick={() => setEditOpen(true)}>
                    Modifier
                </Button>
            </div>

            <Tabs
                className="mt-6"
                defaultActiveKey="parts"
                items={[
                    {
                        key: "parts",
                        label: "Parties",
                        children: <FormationParts formationId={formation.id} onChange={load} />,
                    },
                    {
                        key: "prices",
                        label: "Prix",
                        children: <FormationPrices formationId={formation.id} onChange={load} />,
                    },
                    {
                        key: "students",
                        label: "Apprenantes",
                        children: <FormationStudents formationId={formation.id} onChange={load} />,
                    },
                ]}
            />
        </>
    );
};

export default ShowFormation;
